import { Component } from '@angular/core';
import { ParametreNavService } from 'app/services/parametre/parametre-nav.service';

@Component({
  selector: 'app-logiciel-caisse-parametre-progress',
  templateUrl: './logiciel-caisse-parametre-progress.component.html',
  styleUrls: ['./logiciel-caisse-parametre-progress.component.scss'],
})
export class LogicielCaisseParametreProgressComponent {
  loading$ = this.navService.loading$;
  progress$ = this.navService.progress$;

  constructor(private readonly navService: ParametreNavService) {}
}
